import { AvField, AvForm, AvInput } from "availity-reactstrap-validation"
import { useState, useEffect } from "react"
import DataTable from "react-data-table-component"
import { Col, Row } from "reactstrap"
import Application from "services/applications/Application.service"

let appService = null
let plasticsUser = null

appService = new Application(localStorage.getItem("authUser"))
plasticsUser = appService.getStrategy("officer")

const OtherConsmptionItems = props => {
  const [columns, setcolumns] = useState([])
  const [rows, setrows] = useState([])

  useEffect(() => {
    prepare()
  }, [])

  const prepare = () => {
    let consumptionArea =
      props.appDetails.auth_plastic_bags.consumption_area.name
    let consumptionItems = props.appDetails.application_consumption_area_items
    if (consumptionItems != undefined && consumptionItems.length > 0) {
      let consumptionAreadId =
        props.appDetails.auth_plastic_bags.consumption_area.id

      let cols = [
        {
          name: "Consumption Area",
          selector: "consumption_area",
        },
        {
          name: "Item",
          selector: "actions",
        },
      ]
      setcolumns(cols)

      let rws = consumptionItems
        .filter(item => item.consumption_area_item.is_endorsed == false)
        .map(item => {
          let itemName = item.consumption_area_item.name
          let itemId = item.consumption_area_item.id

          return {
            consumption_area: consumptionArea,
            actions: (
              <Item
                data={{
                  consumption_area_item_name: itemName,
                  consumption_area_item_id: itemId,
                  consumption_area_id: consumptionAreadId,
                }}
              />
            ),
          }
        })

      setrows(rws)
    }
  }
  return (
    <>
      {rows.length > 0 ? (
        <>
          <div className="alert alert-primary">
            The applicant has chosen to submit custom items to be packaged. As
            an officer you can choose to make these items publicly visible to
            all other future applicants by clicking on the endorse button.
            <br></br>
            <br></br>
            If you do not wish for other future applicants to see the items
            below, you can skip this section.
            <br></br> <br></br>
          </div>
          <DataTable columns={columns} data={rows} highlightOnHover />
        </>
      ) : null}
    </>
  )
}

const Item = props => {
  const [itemName, setitemName] = useState(
    props.data.consumption_area_item_name
  )
  const [areaId, setareaId] = useState(props.data.consumption_area_id)
  const [itemId, setitemId] = useState(props.data.consumption_area_item_id)
  const [showEndorseButton, setshowEndorseButton] = useState(true)

  const endorse = () => {
    if (!validate()) {
      alert("Consumption Item Name cannot be empty!")
      return
    }
    if (
      confirm(
        "By clicking Ok, you are proceeding with endorsing this custom item to be packaged. Proceed?"
      )
    ) {
      let item = itemName.trim()

      //   submit
      let data = {
        consumption_area_item_id: itemId,
        consumption_area_id: areaId,
        name: itemName,
        is_endorsed: true,
      }

      plasticsUser.updateConsumptionAreaItem(data).then(response => {
        if (response.status) {
          alert("Item endorsed successfully!")
          setshowEndorseButton(false)
        } else {
            alert("Error endorsing item. Please try again.")
        }
      })
    }
  }

  const validate = () => {
    let itm = itemName.trim()
    if (itm == "") {
      return false
    }
    return true
  }
  return (
    <>
      <Row>
        <Col md={8}>
          <input
            className="form-control"
            type="text"
            name="item_name"
            value={props.data.consumption_area_item_name}
            required
            readOnly={!showEndorseButton}
          />
        </Col>
        <Col md={4}>
          {showEndorseButton ? (
            <button className="btn btn-primary" onClick={endorse}>
              Endorse
            </button>
          ) : (
            <button className="alert alert-success">Endorsed</button>
          )}
        </Col>
      </Row>
    </>
  )
}

export default OtherConsmptionItems
